"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _withTheme = require("../../wrappers/with-theme");

var _utils2 = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _default = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var large = _ref.large,
      small = _ref.small,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _onChange = _ref.onChange,
      value = _ref.value,
      _ref$showClear = _ref.showClear,
      showClear = _ref$showClear === void 0 ? false : _ref$showClear,
      props = _objectWithoutProperties(_ref, ["large", "small", "className", "onChange", "value", "showClear"]);

  var theme = (0, _withTheme.useTheme)(),
      inputTheme = theme["input".concat((0, _utils.composeOptions)({
    large: large,
    small: small
  }))];
  return showClear ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, props, {
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    value: (0, _utils2.hasValue)(value) ? value : "",
    className: "".concat(inputTheme, " ").concat(className),
    ref: ref
  })), !(0, _utils2.hasValue)(value) ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute right-0 ".concat(small ? "mr-1" : "mr-2", " top-0 bottom-0 flex items-center")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n                ".concat(theme.menuBgActive, " ").concat(theme.menuBgActiveHover, " ").concat(theme.textContrast, "\n                p-1 flex justify-center items-center rounded cursor-pointer\n              "),
    onClick: function onClick(e) {
      return _onChange("");
    }
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "8",
    height: "8"
  }, /*#__PURE__*/_react["default"].createElement("line", {
    x2: "8",
    y2: "8",
    style: {
      stroke: "currentColor",
      strokeWidth: 2
    }
  }), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "8",
    x2: "8",
    style: {
      stroke: "currentColor",
      strokeWidth: 2
    }
  }))))) : /*#__PURE__*/_react["default"].createElement("input", _extends({}, props, {
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    value: (0, _utils2.hasValue)(value) ? value : "",
    className: "".concat(inputTheme, " ").concat(className),
    ref: ref
  }));
});

exports["default"] = _default;